import React from 'react'
import PropTypes from 'prop-types'
import { useIntl } from 'react-intl'
import { Link, Text } from 'mailup-web-components'
import { notifyParent } from 'Helpers/notifyParent'

const SendingsLimitWarningMessage = ({ remainingSendings, goToMShop }) => {
  const intl = useIntl()

  return (
    <div key='limitWarning'>
      {remainingSendings < 1 && goToMShop && (
        <Text key='noRemaining'>
          {intl.formatMessage(
            {
              id: 'Load.EmailSendingWizard.TotalLimitWarningLimit'
            },
            {
              link: chunks => (
                <Link
                  key='noRemainingLink'
                  onClick={() =>
                    notifyParent('redirectMainFrame', [
                      '/console/mshop_Redirector.aspx?t=mshopem'
                    ])
                  }
                >
                  {chunks}
                </Link>
              )
            }
          )}
        </Text>
      )}
      {remainingSendings < 1 && !goToMShop && (
        <Text key='noRemainingComm'>
          {intl.formatMessage({
            id: 'Load.EmailSendingWizard.TotalLimitWarningNewLimitComm'
          })}
        </Text>
      )}
    </div>
  )
}

SendingsLimitWarningMessage.propTypes = {
  remainingSendings: PropTypes.number,
  goToMShop: PropTypes.bool
}

export default SendingsLimitWarningMessage
